// extracted by mini-css-extract-plugin
export default {"navigation":"Navbar_navigation__80OTf","logo":"Navbar_logo__+Swf+","nav_list":"Navbar_nav_list__2xRiL","nav_a":"Navbar_nav_a__KZitE","signin":"Navbar_signin__vscX0"};